import { ApplicationConfig } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { provideAssetImages } from '@web/shared/ui';
import { AppAssetImagesProviderService } from '../config/providers/app-asset-images-provider.service';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideEnvironment } from '@web/config';
import { environment } from '../environments/environment';
import {
  provideCustomTitleStrategyConfig,
  provideHttpErrorHandlers,
  providePrimengConfiguration,
  provideRoutes,
  provideTitles,
} from '@web/common';
import { provideUserContext } from '@web/shared/module/auth';
import {
  AuthTokenInterceptor,
  BadRequestHttpErrorHandler,
  CacheInterceptor,
  HttpBlobResponseErrorInterceptor,
  HttpErrorInterceptor,
  HttpLoadingInterceptor,
  RefreshTokenInterceptor,
  UnknownErrorMessageHandler,
  UnprocessableEntityErrorHandler,
  UnsupportedMediaTypeErrorHandler,
} from '@web/core';
import { AppRoutesProviderService } from '../config/providers/app-routes-provider.service';
import { AppRouteTitlesProviderService } from '../config/providers/app-route-titles-provider.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
    ),
    provideAnimations(),
    provideAnimationsAsync(),
    provideAssetImages(AppAssetImagesProviderService),
    provideRoutes(AppRoutesProviderService),
    provideTitles(AppRouteTitlesProviderService),
    provideClientHydration(),
    provideCustomTitleStrategyConfig(),
    provideEnvironment(environment),
    provideHttpErrorHandlers([
      BadRequestHttpErrorHandler,
      UnsupportedMediaTypeErrorHandler,
      UnprocessableEntityErrorHandler,
      UnknownErrorMessageHandler,
    ]),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        AuthTokenInterceptor,
        CacheInterceptor,
        HttpErrorInterceptor,
        HttpBlobResponseErrorInterceptor,
        HttpLoadingInterceptor,
        RefreshTokenInterceptor({ shouldSignOutAfterTokenRefreshError: true }),
      ]),
    ),
    provideUserContext(),
    providePrimengConfiguration(),
  ],
};
